import { GridValidRowModel } from "@mui/x-data-grid";
import { useState } from "react";
import { getContractSweepRequestRecordResubmit } from "src/api/contactSweepRequestRecord";
import Prompter from "src/components/Prompter";
import { Params } from "src/features/common/types/GridRenderCellParams";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useAlerting, useTranslation } from "src/hooks";
import ResubmitButton from "src/views/Tools/ReSubmit/components/ResubmitButton";
import ResubmitPrompterContent from "src/views/Tools/ReSubmit/components/ResubmitPrompterContent";
import { checkIsResubmitBtnDisabled } from "src/views/Tools/ReSubmit/helper/check-is-resubmit-btn-disabled";
import { GetListRes } from "../types/GetListRes";
import { TableColumnKey } from "../types/Table";

const useOperationCell = () => {
  const { translatePrefix, onFilterSearch } = usePageConfigProviderContext();
  const { translate } = useTranslation(translatePrefix);
  const { alerting } = useAlerting();
  const [isResubmitPrompterOpen, setIsResubmitPrompterOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<
    GridValidRowModel & { rawData: GetListRes }
  >();

  const renderOperationCell = (params: Params<GetListRes>) => {
    const status = params.row.rawData?.batch?.status;
    const isBtnDisabled = checkIsResubmitBtnDisabled(status);

    const handleClick = () => {
      setIsResubmitPrompterOpen(true);
      setSelectedRowData(params.row);
    };
    return <ResubmitButton onClick={handleClick} isDisabled={isBtnDisabled} />;
  };

  const handleResubmitYes = async () => {
    const payload = {
      batch_id: selectedRowData?.[TableColumnKey.BatchId],
    };
    const res = await getContractSweepRequestRecordResubmit(payload);
    if (res) {
      alerting("success", translate("resubmit.alert.success"));
      onFilterSearch();
    }
  };

  const renderResubmitPrompter = () => {
    return (
      <Prompter
        title={translate("resubmit.prompter.title")}
        open={isResubmitPrompterOpen}
        onClose={() => setIsResubmitPrompterOpen(false)}
        content={
          <ResubmitPrompterContent
            batch_id={selectedRowData?.[TableColumnKey.BatchId]}
            chain_name={selectedRowData?.[TableColumnKey.ChainName]}
            asset_name={selectedRowData?.[TableColumnKey.Currency]}
            total_amount={selectedRowData?.[TableColumnKey.TotalCount]}
          />
        }
        onYes={handleResubmitYes}
      />
    );
  };

  return { renderOperationCell, renderResubmitPrompter };
};
export default useOperationCell;
